/*

    template

    WORK EXPERIENCE
    {
        position: "Junior Software Developer",
        company: "",
        duration: "Jun 2022 to present",
        logo: "",
        responsibilities: ["", ""],
    },

    - array of responsibilities for those with dot points

    EDUCATION 
    {
        educationProvider: "",
        degree: "",
        duration: "",
    },

    CERTIFICATIONS
    {
        name: "", 
        expDate: "", 
    }
*/

export const workExperience = [
    {
        position: "Junior Software Developer",
        company: "_nology",
        duration: "Jun 2022 to present",
        logo: "https://avatars.githubusercontent.com/u/43138473?s=200&v=4",
        responsibilities: [
            "Full-time training with expert coaches covering key areas of programming including concepts in the following languages: HTML, CSS, SCSS, JavaScript, React, Java, Microservices, Google Cloud Platform, Testing strategy, and Agile projects.",
        ],
        id: "00001",
    },
    {
        position: "3IC Team Member",
        company: "kikki.K",
        duration: "Apr 2021 to Apr 2022",
        logo: "https://media-exp1.licdn.com/dms/image/C4E0BAQFSSUYk4KhWqg/company-logo_200_200/0/1519871538567?e=1668643200&v=beta&t=sisggb7sH1Yxo2eWFDgtbb1UwrufRn3llhIcQzlu4RI",
        responsibilities: [
            "Built a system to streamline over 200+ guest orders and requests for call backs",
            "Coached, mentored, and supported new hires in learning systems and processes in absence of store manager",
            "Greeted customers, built rapport, and handled payments via a POS system fulfilling 100+ transactions per shift",
            "Maintained clean store floor and workstations by routinely vacuuming, mopping, replenishing supplies, and disposing of trash",
            "Collaborated with team to maintain smooth operations and high standards of customer service during high volume periods",
            "Organised and curated displays of merchandise in accordance with visual merchandising communications",
        ],
        id: "00002",
    },
    {
        position: "Group Fitness Instructor",
        company: "Kick N Box Fitness Studio",
        duration: "Jul 2020 to May 2021",
        logo: "https://scontent.fmel16-1.fna.fbcdn.net/v/t1.18169-9/29683618_1732622890132167_2733339262704059772_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=juzki4c6sXsAX9cCjFU&_nc_ht=scontent.fmel16-1.fna&oh=00_AT-74u3FJ9KXx4SmsSbKPxoGiZDA5bXxjHSeHsSVLt1HoQ&oe=63210ABC",
        responsibilities: [
            "Designed and implemented fitness routines for a variety of clients with different fitness levels and backgrounds",
            "Provided a safe, warm, and welcoming gym environment by connecting and building rapport with new and existing clients",
            "Encouraged clients to push through their limits as necessary to achieve their goals whilst prioritising safety and longevity",
        ],
        id: "00003",
    },
    {
        position: "Receptionist",
        company: "Kick N Box Fitness Studio",
        duration: "Sep 2019 to Apr 2021",
        logo: "https://scontent.fmel16-1.fna.fbcdn.net/v/t1.18169-9/29683618_1732622890132167_2733339262704059772_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=juzki4c6sXsAX9cCjFU&_nc_ht=scontent.fmel16-1.fna&oh=00_AT-74u3FJ9KXx4SmsSbKPxoGiZDA5bXxjHSeHsSVLt1HoQ&oe=63210ABC",
        responsibilities: [
            "Welcomed 100+ clients, visitors, and other stakeholders with high levels of customer service",
            "Maintained displays in a neat and orderly fashion and replenished stock levels",
            "Complied with COVID-19 policies and procedures ensuring equipment and restroom facilities were deep cleaned and sanitised in accordance with health and safety standards",
            "Utilise Xero to complete invoices",
        ],
        id: "00004",
    },
    {
        position: "Retail Assistant",
        company: "Kmart Australia Limited",
        duration: "Oct 2017 to Oct 2020",
        logo: "https://media-exp1.licdn.com/dms/image/C560BAQGK4sh6htkaiA/company-logo_200_200/0/1643747367981?e=1668643200&v=beta&t=jp3vwupjcxHGwk0tTs6MXFwFKmyakYxnicd8M9DqdBU",
        responsibilities: [
            "Anticipated customer needs and provided high levels of customer service while upholding brand standards and values to ensure customer satisfaction",
            "Operated and managed POS system transactions including cash, credit, exchanges, returns, and refunds for a seamless and accurate cash flow ",
            "Welcomed 300+ customers into store per shift and offered advice and help with finding merchandise",
        ],
        id: "00005",
    },
    {
        position: "Intern",
        company: "Tamago DB",
        duration: "Oct 2018 to Nov 2018",
        logo: "https://scontent.fmel16-1.fna.fbcdn.net/v/t1.6435-9/91454060_2852846528137632_8506922593679310848_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=1X52pHlB2QcAX-yCLRm&_nc_ht=scontent.fmel16-1.fna&oh=00_AT8e4PWAXA3AoWXHsqPHUBRtY806tROJzA88BTB1y5v81Q&oe=6320DE20",
        responsibilities: [
            "Collaborate with team to build plug-in using HTML, CSS, and PHP coding languages",
            "Utilised WordPress to create a prototype using the plug-in built",
            "Translated feedback into improvements and changes in performance",
        ],
        id: "00006",
    },
];

export const education = [
    {
        educationProvider: "University of Adelaide",
        logo: "https://www.adelaide.edu.au/brand/sites/default/files/styles/ua_landscape/public/media/images/2021-09/uoalogonavybg.png?h=c4dd2c7b&itok=836Wuw_K",
        degree: "Bachelor of Commerce",
        duration: "Mar 2021 to (currently deffered)",
        id: "001",
    },
    {
        educationProvider: "University of South Australia",
        logo: "https://media-exp1.licdn.com/dms/image/C560BAQHMHqwljNA2uw/company-logo_200_200/0/1614575914322?e=1668643200&v=beta&t=VT0IGwmr1JnE92Su1Cgdolw0cABUimQmKRprHwVNNjw",
        degree: "Bachelor of Arts Languages",
        duration: "Mar 2016 to Apr 2019",
        id: "002",
    },
    {
        educationProvider: "Fit College",
        logo: "https://www.fitcollege.edu.au/library/FitCollege/images/logo.jpg",
        degree: "Cert III in Fitness",
        duration: "Issued May 2020",
        id: "003",
    },
];
